import { API } from "../api/axios";
const END_POINT = "/homeworks";
const END_POINT_HW = "/homework";
const END_POINT_FILTER_DEV= "/homeworks-filter";
 const END_POINT_FILTER = "/custom-homeworks-filter";
const END_POINT_HW_ADD = "/homework-web";
const END_POINT_STATS ="homeworks-statistics";
const STUDENT_LIST ="student-list"
class HomeWorkService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    getFilter(params) {
        return API.get(END_POINT_FILTER, params);
    }
    getFilterDev(params) {
        return API.get(END_POINT_FILTER_DEV, params);
    }
    get(id) {
        return API.get(`${END_POINT_HW}${END_POINT}/${id}`);
    }
    getListStudents(id,params) {
        return API.get(`${STUDENT_LIST}${END_POINT_HW}/${id}`,params);
    }
    getStat(params) {
        return API.get(END_POINT_STATS, params);
    }
    create(data) {
        return API.post(END_POINT_HW_ADD, data);
    }

    update(id, data) {
        return API.post(`${END_POINT_HW}/${id}`, data);
    }

    delete(id) {
        return API.delete(`${END_POINT_HW}/${id}`);
    }

    deleteAll(params) {
        return API.delete(`${END_POINT}`, params);
    }
}

export default new HomeWorkService();

//Exemple d'utilisation dans les pages
/*getMessage(id) {
    MessageDataService.get(id)
    .then(response => {
    this.currentMessage = response.data;
    })
    .catch(e => {
    });
},*/
